import css from "./QuestBlock.module.css";
import { Link } from "react-router";
import { Icon } from "../ui/Icon";
import { useT, useTurl } from "~/util/Lang";
import { questCategories } from "~/util/quest";
import { Heading2 } from "../ui/Heading";

type QuestCategory = {
  name: {
    en: string;
    ru: string;
  };
  icon: string;
  quests: number[];
  path: string;
};

type QuestList = {
  name: {
    en: string;
    ru: string;
  };
  categories: QuestCategory[];
}[];

export function QuestBlock() {
  return (
    <div style={{ marginBottom: 20 }}>
      <Heading2>Quests</Heading2>
      <section className={css.root}>
        <QuestList quests={questCategories} />
        <AllQuests />
      </section>
    </div>
  );
}

function QuestList(params: { quests: QuestList }) {
  const t = useT();

  return params.quests.map((q, i) => (
    <section className={css.grouWrapper} key={i}>
      <section className={css.group}>
        <section className={css.groupName}>{t(q.name)}</section>
        {q.categories.map((c, j) => (
          <QuestCategoryItem quest={c} key={j} />
        ))}
      </section>
    </section>
  ));
}

function QuestCategoryItem(params: { quest: QuestCategory }) {
  const t = useT();
  const turl = useTurl();

  return (
    <section>
      <Link to={turl(`/quests/${params.quest.path}`)}>
        <Icon
          icon={params.quest.icon}
          size={16}
          alt={`Icon Quest ${t(params.quest.name)}`}
        />
        {t(params.quest.name)}
      </Link>
    </section>
  );
}

function AllQuests() {
  const t = useT();
  const turl = useTurl();

  return (
    <section className={css.grouWrapper}>
      <section className={css.group}>
        <section>
          <Link to={turl(`/quests`)}>
            {t({ en: "All Quests", ru: "Все квесты" })}
          </Link>
        </section>
      </section>
    </section>
  );
}
